import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, OnDestroy } from '@angular/core';

import { SportModel } from '@frontend/sports/betting-offer/feature/model';
import { TopEventsConfig } from '@frontend/sports/common/client-config-data-access';
import { GridGrouping } from '@frontend/sports/grid/core/feature/model';
import { ObservableGrid, ObservableGridFactory } from '@frontend/sports/grid/core/feature/observables';
import { groupBy, indexOf, keys, sortBy } from 'lodash-es';
import { Subscription } from 'rxjs';

import { PodType, TopEventsPodData } from '../top-events.model';

@Component({
    selector: 'ms-top-events-grid',
    templateUrl: 'top-events-grid.component.html',
    providers: [ObservableGridFactory],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TopEventsGridComponent implements OnChanges, OnDestroy {
    @HostBinding('class') className = 'grid-pod';

    @Input() pod: TopEventsPodData;
    @Input() allowHeaderCollapse = true;

    tracking = `TopEvents/Sport|${PodType.Grid}`;
    trackingModuleType = PodType.Grid;
    grids: ObservableGrid[] = [];

    private readonly maxEvents = 10;
    private transitions: Subscription[] = [];

    constructor(
        private gridFactory: ObservableGridFactory,
        private topEventsConfig: TopEventsConfig,
    ) {}

    ngOnChanges(): void {
        this.setGridData();
    }

    private setGridData() {
        this.cleanUpGrid();

        const competitionOrder = this.pod.fixtures.map((f) => f.competition.parentLeagueId?.toString() ?? f.competition.id.toString());
        const fixturesByCompetition = groupBy(this.pod.fixtures, (f) => f.competition.parentLeagueId ?? f.competition.id);

        this.grids = sortBy(keys(fixturesByCompetition), (id) => indexOf(competitionOrder, id)).map((competitionId) => {
            return this.gridFactory.fromResponse(
                this.pod.podId + '/TopEvents/' + competitionId,
                fixturesByCompetition[competitionId].slice(0, this.topEventsConfig.maxEventsPerPod || this.maxEvents),
                {
                    grouping: GridGrouping.League,
                    disableGroupSorting: true,
                },
            );
        });
    }

    ngOnDestroy(): void {
        this.cleanUpGrid();
    }

    private cleanUpGrid(): void {
        this.grids?.forEach((g) => g?.destroy());
        this.transitions?.forEach((t) => t?.unsubscribe());

        this.grids = this.transitions = [];
    }

    getSport(sport: SportModel): string {
        return `icon sports-${sport.id}`;
    }
}
